import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useState, useMemo, useEffect } from "react";
import "lottie-react";
import "../../../themes/shadows/shadows.js";
import "../../../themes/typography/typography.js";
import "../../../components/avatar-group/avatar-group.styles.js";
import "@mui/material";
import "../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../components/date-pickers/date-picker/theme/index.js";
import "../../../components/dialog/dialog.js";
import "../../../components/icons/all/all.js";
import "../../../components/label/label.styles.js";
import { Loader } from "../../../components/loader/loader.js";
import "../../../components/menu-item/menu-item.js";
import "../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import "../../../components/snackbar/snackbar.styles.js";
import "../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../components/translations/utils.js";
import "../../../components/time-select/time-select.styles.js";
import "../../../components/time-interval-select/time-interval-select.styles.js";
import { addDays, isSunday, addBusinessDays, format, isWeekend, isPast, startOfDay, previousMonday, nextMonday, addMonths, isMonday } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { orderBy } from "lodash";
import { Swiper, SwiperSlide } from "swiper/react";
import { getDatesBetween, getMaxSlots, useDateFnsLocale } from "./appointments-picker.helpers.js";
import { PatientHeader, PatientPeriod, Card, DatesWrap, WorkingDaysContainer, WorkingDaysHeader, WorkingDays, WorkingSlotsContainer, WorkingDayContainer, WorkingSlots, LoadMoreContainer, LoadMore, ExpandMoreIcon, ClinicHeaderCardContent, ClinicCurrentMonthHeader } from "./appointments-picker.styles.js";
import AvailableSlot from "./components/AvailableSlot/AvailableSlot.js";
import CurrentPeriod from "./components/CurrentPeriod/CurrentPeriod.js";
import NextPeriod from "./components/NextPeriod/NextPeriod.js";
import PrevPeriod from "./components/PrevPeriod/PrevPeriod.js";
import QuickFilter from "./components/QuickFilter/QuickFilter.js";
import TimeFrames from "./components/TimeFrames/TimeFrames.js";
import UnavailableSlot from "./components/UnavailableSlot/UnavailableSlot.js";
import WorkingDay from "./components/WorkingDay/WorkingDay.js";
import "./constants/dataTestIds.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../constants/create-theme/create-theme.js";
import "../../../constants/colors/palette.js";
import "../../../themes/button/button.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../themes/date-calendar/date-calendar.js";
import "../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../themes/day-calendar/day-calendar.js";
import "../../../themes/filled-input/filled-input.js";
import "../../../themes/form-helper-text/form-helper-text.js";
import "../../../themes/form-label/form-label.js";
import "../../../themes/month-calendar/month-calendar.js";
import "../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../themes/pickers-month/pickers-month.js";
import "../../../themes/pickers-popper/pickers-popper.js";
import "../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../themes/pickers-year/pickers-year.js";
import "../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../themes/alert/alert.js";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/dialog/dialog.js";
import "../../../themes/external-theme/external-theme.js";
import "../../../constants/breakpoints/breakpoints.js";
import "../../../themes/checkbox/checkbox.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/form-control-label/form-control-label.js";
import "../../../themes/radio/radio.js";
import "../../../themes/switch/switch.js";
import "../../../themes/popover/popover.js";
import "../../../themes/tooltip/tooltip.js";
import "../../../components/dialog/dialog.constants.js";
import "../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../components/icons/MainIcon/MainIcon.js";
import "../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../components/icons/CardIcon/CardIcon.js";
import "../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../components/icons/EditIcon/EditIcon.js";
import "../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../components/icons/EventNote/EventNote.js";
import "../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../components/icons/ListIcon/ListIcon.js";
import "../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../components/icons/PinIcon/PinIcon.js";
import "../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../components/icons/WarningIcon/WarningIcon.js";
import "../../../components/loader/data.js";
import "../../../components/animation/animation.js";
import "../../../components/loader/loader.styles.js";
import "@mui/material/MenuItem/index.js";
import "../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../components/menu-item/menu-item.styles.js";
import "../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../components/avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../components/snackbar/snackbar.types.js";
import "../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../components/text-field/text-field.styles.js";
import "../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Box/index.js";
import "date-fns/locale/de";
import "date-fns/locale/en-US";
import "@mui/icons-material/ArrowBackIos.js";
import "@mui/icons-material/ExpandMore.js";
import "@mui/material/Card/index.js";
import "@mui/material/CardContent/index.js";
import "clsx";
import "./components/AvailableSlot/AvailableSlot.styles.js";
import "./components/CurrentPeriod/CurrentPeriod.styles.js";
import "./components/NextPeriod/NextPeriod.styles.js";
import "@mui/icons-material/KeyboardArrowRight.js";
import "./components/PrevPeriod/PrevPeriod.styles.js";
import "@mui/icons-material/KeyboardArrowLeft.js";
import "./components/QuickFilter/QuickFilter.styles.js";
import "@mui/icons-material/Check.js";
import "./components/TimeFrames/TimeFrames.styles.js";
import "./components/UnavailableSlot/UnavailableSlot.styles.js";
import "./components/WorkingDay/WorkingDay.styles.js";
var FilterKind = /* @__PURE__ */ ((FilterKind2) => {
  FilterKind2["Clinic"] = "Clinic";
  FilterKind2["Patient"] = "Patient";
  return FilterKind2;
})(FilterKind || {});
var CALENDAR_DIRECTIONS = /* @__PURE__ */ ((CALENDAR_DIRECTIONS2) => {
  CALENDAR_DIRECTIONS2["NEXT"] = "next";
  CALENDAR_DIRECTIONS2["PREV"] = "prev";
  return CALENDAR_DIRECTIONS2;
})(CALENDAR_DIRECTIONS || {});
const TRANSITION_TIME_IN_SECONDS = 0.25;
const AppointmentDateTimePicker = ({
  data,
  isDataLoading,
  timeFramesFilter = false,
  mounting = false,
  timeZone = "Europe/Berlin",
  selected,
  onSlotSelected,
  filter = "Clinic",
  onLoadMore,
  withDashes,
  firstDay,
  setFirstDay,
  lastDay,
  setLastDay,
  scrollSlots,
  maxSlotsPerDay,
  daysBackgroundColor = "white",
  setMaxSlotsPerDay,
  onSetFilterSlots,
  lang,
  labels: { loadMore, noSlots, week, quickFilterToday, quickFilterSixMonths, quickFilterOneYear, ...dayTime },
  Alert,
  keepTimezone,
  includeWeekends = false,
  ...rest
}) => {
  const [dates, setDates] = useState([]);
  const freeSlots = useMemo(() => data || [], [data]);
  useEffect(() => {
    if (includeWeekends) {
      setLastDay(addDays(firstDay, 6));
    } else if (isSunday(firstDay)) {
      setLastDay(addBusinessDays(firstDay, 5));
    } else {
      setLastDay(addBusinessDays(firstDay, 4));
    }
  }, [firstDay]);
  useEffect(() => {
    const nextDates = getDatesBetween(firstDay, lastDay, includeWeekends);
    setDates(nextDates);
  }, [firstDay, lastDay]);
  const missingSlots = useMemo(
    () => dates.filter((date) => {
      return !(freeSlots == null ? void 0 : freeSlots.some((slotsPerDate) => {
        return slotsPerDate.date === format(date, "yyyy-MM-dd");
      }));
    }).map((date) => ({ date, slots: [...Array(getMaxSlots(freeSlots))] })),
    [dates, freeSlots]
  );
  const existingSlots = useMemo(
    () => freeSlots == null ? void 0 : freeSlots.map((slotsPerDate) => {
      const slotsToBeAdded = getMaxSlots(freeSlots) - slotsPerDate.slots.length;
      if (slotsPerDate.slots.length < getMaxSlots(freeSlots)) {
        return {
          date: utcToZonedTime(new Date(slotsPerDate.date), timeZone),
          slots: [...slotsPerDate.slots, ...Array(slotsToBeAdded)]
        };
      }
      return {
        date: utcToZonedTime(new Date(slotsPerDate.date), timeZone),
        slots: [...slotsPerDate.slots]
      };
    }),
    [freeSlots]
  );
  const datesWithSlots = [...missingSlots, ...existingSlots || []];
  const datesExcludingWeekend = datesWithSlots.filter(({ date }) => !isWeekend(date));
  const sortedDatesWithSlots = orderBy(
    includeWeekends ? datesWithSlots : datesExcludingWeekend,
    (slotsPerDate) => slotsPerDate.date,
    ["asc"]
  );
  const canShowMore = (includeWeekends ? datesWithSlots : datesExcludingWeekend).length <= (includeWeekends ? 7 : 5) && (freeSlots == null ? void 0 : freeSlots.length) > 0 && maxSlotsPerDay;
  const onPeriodBack = () => {
    setMaxSlotsPerDay(5);
    const moved = previousMonday(firstDay);
    setFirstDay(moved);
  };
  const onPeriodForward = () => {
    setMaxSlotsPerDay(5);
    const moved = nextMonday(firstDay);
    setFirstDay(moved);
  };
  const handleJumpMonths = (months) => {
    setMaxSlotsPerDay(5);
    const targetDate = addMonths(/* @__PURE__ */ new Date(), months);
    const moved = isMonday(targetDate) ? targetDate : previousMonday(targetDate);
    setFirstDay(moved);
  };
  const handleResetToToday = () => {
    setMaxSlotsPerDay(5);
    const moved = startOfDay(/* @__PURE__ */ new Date());
    setFirstDay(moved);
  };
  const canGoBack = !isPast(startOfDay(firstDay));
  const handleSlotChange = (slots) => {
    onSetFilterSlots == null ? void 0 : onSetFilterSlots(slots);
  };
  const handleSlotSelect = (slot) => (date) => onSlotSelected == null ? void 0 : onSlotSelected(date, slot);
  const Processing = /* @__PURE__ */ jsx(LoadMoreContainer, { children: /* @__PURE__ */ jsx(Loader, { size: "lg" }) });
  const ClinicFilter = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(ClinicHeaderCardContent, { children: [
      /* @__PURE__ */ jsxs(ClinicCurrentMonthHeader, { children: [
        /* @__PURE__ */ jsx(PrevPeriod, { disabled: !canGoBack, onClick: onPeriodBack }),
        /* @__PURE__ */ jsx(CurrentPeriod, { lang, dates, labels: { week } }),
        /* @__PURE__ */ jsx(NextPeriod, { onClick: onPeriodForward })
      ] }),
      Alert,
      timeFramesFilter && /* @__PURE__ */ jsx(TimeFrames, { onSelectSlot: handleSlotChange, labels: dayTime })
    ] }),
    /* @__PURE__ */ jsx(
      QuickFilter,
      {
        onJumpMonths: handleJumpMonths,
        onReset: handleResetToToday,
        labels: { quickFilterToday, quickFilterSixMonths, quickFilterOneYear }
      }
    )
  ] });
  const locale = useDateFnsLocale(lang);
  const PatientFilter = /* @__PURE__ */ jsxs(PatientHeader, { children: [
    /* @__PURE__ */ jsx(PrevPeriod, { onClick: onPeriodBack, disabled: !canGoBack }),
    /* @__PURE__ */ jsx(PatientPeriod, { children: dates.length >= (includeWeekends ? 7 : 5) && /* @__PURE__ */ jsxs(Fragment, { children: [
      format(dates[0], "d MMM", { locale }),
      " - ",
      format(dates[dates.length - 1], "d MMM yyyy", { locale })
    ] }) }),
    /* @__PURE__ */ jsx(NextPeriod, { onClick: onPeriodForward })
  ] });
  const Filter = {
    [
      "Clinic"
      /* Clinic */
    ]: ClinicFilter,
    [
      "Patient"
      /* Patient */
    ]: PatientFilter
  };
  const swipeToPeriod = (direction) => {
    if (!direction)
      return;
    if (direction === "prev" && !canGoBack)
      return;
    setTimeout(() => {
      if (direction === "next" && onPeriodForward) {
        onPeriodForward();
      } else if (direction === "prev" && canGoBack) {
        onPeriodBack();
      }
    }, TRANSITION_TIME_IN_SECONDS * 1e3);
  };
  return mounting ? Processing : /* @__PURE__ */ jsxs(Card, { includeWeekends, ...rest, children: [
    Filter[filter],
    dates.length > 0 && /* @__PURE__ */ jsx(
      Swiper,
      {
        onTouchEnd: (swipe) => {
          if (Math.abs(swipe.touches.diff) < 50)
            return;
          const direction = swipe.touches.diff > 0 ? "prev" : "next";
          swipeToPeriod(direction);
        },
        children: /* @__PURE__ */ jsx(SwiperSlide, { children: /* @__PURE__ */ jsx(DatesWrap, { children: /* @__PURE__ */ jsxs(WorkingDaysContainer, { scroll: !!scrollSlots, children: [
          /* @__PURE__ */ jsx(WorkingDaysHeader, { color: daysBackgroundColor, children: /* @__PURE__ */ jsx(WorkingDays, { children: dates.length <= (includeWeekends ? 7 : 5) && dates.map((date) => /* @__PURE__ */ jsx(WorkingDay, { lang, workingDate: date }, `month_${date.toISOString()}`)) }) }),
          /* @__PURE__ */ jsx(WorkingSlotsContainer, { children: sortedDatesWithSlots.length <= (includeWeekends ? 7 : 5) && sortedDatesWithSlots.map((slotsPerDate) => {
            var _a;
            return /* @__PURE__ */ jsx(WorkingDayContainer, { children: /* @__PURE__ */ jsx(WorkingSlots, { children: (_a = slotsPerDate.slots) == null ? void 0 : _a.map((slot, index) => {
              if (!slot) {
                return /* @__PURE__ */ jsx(UnavailableSlot, { visible: withDashes }, `unavailable-${index}`);
              }
              return /* @__PURE__ */ jsx(
                AvailableSlot,
                {
                  start: selected ?? "",
                  lang,
                  dateString: slot.start,
                  onSlotSelected: handleSlotSelect(slot),
                  keepTimezone,
                  priority: slot == null ? void 0 : slot.priority
                },
                slot.start
              );
            }) }) }, `slots_container_${slotsPerDate.date}`);
          }) }),
          canShowMore && /* @__PURE__ */ jsx(LoadMoreContainer, { children: /* @__PURE__ */ jsxs(LoadMore, { onClick: onLoadMore, variant: "borderless", children: [
            loadMore,
            /* @__PURE__ */ jsx(ExpandMoreIcon, {})
          ] }) }),
          isDataLoading && (freeSlots == null ? void 0 : freeSlots.length) === 0 && Processing,
          !isDataLoading && (freeSlots == null ? void 0 : freeSlots.length) === 0 && /* @__PURE__ */ jsx(LoadMoreContainer, { children: noSlots })
        ] }) }) })
      }
    )
  ] });
};
export {
  AppointmentDateTimePicker,
  CALENDAR_DIRECTIONS,
  FilterKind,
  TRANSITION_TIME_IN_SECONDS
};
